import { LoadingLazyComponents } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { lazy } from 'react'
import {
  DOCUMENT_FOLDER_PREFIX_URL,
  DOCUMENT_LIST_PREFIX_URL,
  DOCUMENT_PREFIX_URL,
} from './constants/config.document'

const DetailPage = lazy(() => import('./pages/Page.Detail.Document'))
const ListPage = lazy(() => import('./pages/List.All.Document'))
const FolderPage = lazy(() => import('./pages/List.ByFolder.Document'))
const ReportPage = lazy(() => import('./pages/Report.Document'))

const DocumentRouters: AppRouterItem[] = [
  {
    path: `${DOCUMENT_PREFIX_URL}/report`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ReportPage />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_LIST_PREFIX_URL}`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPage />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_FOLDER_PREFIX_URL}/:documentTypeWithDepId?`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <FolderPage />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_LIST_PREFIX_URL}${DOCUMENT_PREFIX_URL}/:documentId`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <DetailPage />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_LIST_PREFIX_URL}${DOCUMENT_PREFIX_URL}/:documentId/version/:documentDetailId`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <DetailPage />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_FOLDER_PREFIX_URL}${DOCUMENT_PREFIX_URL}/:documentId`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <DetailPage />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_FOLDER_PREFIX_URL}${DOCUMENT_PREFIX_URL}/:documentId/version/:documentDetailId`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <DetailPage />
      </LoadingLazyComponents>
    ),
  },
]

export default DocumentRouters
